import { useEffect } from "react";

// Manejo del botón físico de retroceso de Android para overlays (Google Play:
// Unified Navigation & Back Stack). Cuando hay un modal/sheet/menú abierto
// (cualquier elemento con aria-modal="true" o data-back="true"), presionar
// "atrás" debe cerrar el overlay en vez de navegar fuera o salir de la app.
//
// Estrategia: al abrirse un overlay se empuja una entrada "centinela" en el
// historial. Si el usuario presiona atrás mientras el overlay sigue abierto,
// se re-empuja el centinela (la página no se mueve) y se dispara un Escape
// sintético —todos nuestros overlays cierran con Escape— para que el overlay
// se cierre y la pantalla permanezca. Al cerrarse normalmente, se retira el
// centinela con history.back() solo si la URL no cambió (para no quitar una
// ruta a la que el usuario navegó desde dentro del overlay).
export default function BackHandler() {
  useEffect(() => {
    let depth = 0;          // 1 = centinela activo en el historial
    let sentinelUrl = "";   // URL respaldada al empujar el centinela
    let removing = false;   // true mientras retiramos nuestro propio centinela

    const hasOverlay = () =>
      !!document.querySelector('[aria-modal="true"], [data-back="true"]');

    const observer = new MutationObserver(() => {
      if (removing) return;
      const open = hasOverlay();
      if (open && depth === 0) {
        sentinelUrl = window.location.href;
        window.history.pushState({ bhgcBack: 1 }, "");
        depth = 1;
      } else if (!open && depth === 1) {
        depth = 0;
        if (window.location.href === sentinelUrl) {
          removing = true;
          window.history.back(); // retira el centinela (entrada superior)
        }
        // si la URL cambió (navegó desde el overlay), se deja el centinela
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    const onPop = () => {
      if (removing) { removing = false; return; }
      if (hasOverlay()) {
        // atrás con overlay abierto: re-empuja centinela y cierra el overlay
        sentinelUrl = window.location.href;
        window.history.pushState({ bhgcBack: 1 }, "");
        depth = 1;
        window.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true, cancelable: true }));
      } else {
        depth = 0;
      }
    };
    window.addEventListener("popstate", onPop);

    return () => { observer.disconnect(); window.removeEventListener("popstate", onPop); };
  }, []);
  return null;
}